/* eslint-disable max-len */
export const es = Object.freeze({
  hola: '¡Hola!',
  bienvenido_a: 'Bienvenido a',
  tu_isbm: 'TU ISBM',
  aqui: 'Aquí',
  isbm: 'Instituto Salvadoreño de Bienestar Magisterial',
  direccion_isbm:
    'República de El Salvador, C. A Calle Guadalupe, No. 1349, Colonia Médica, San Salvador',
  apellido: 'Apellido',
  compartenos_tu_opinion: 'Compártenos tu opinión',
  enviar: 'Enviar',
  elige_una_de_las_opciones: 'Elige una de las opciones',
  escribe_tu_comentario: 'Escribe tu comentario',
  selecciona_el_tipo: 'Selecciona el tipo de solicitud',
  estamos_mejorando:
    'Estamos mejorando para ti y conocer tu opinión es muy importante para nosotros.',
  te_invitamos_a_completar:
    'Te invitamos a completar el siguiente formulario, dejándonos tus felicitaciones, sugerencias o quejas. ',
  nombre: 'Nombre',
  elige_una: 'Elige una de las opciones',
  queja: 'Queja',
  sugerencia: 'Sugerencia',
  felicitacion: 'Felicitación',
  email: 'Correo electrónico',
  goes_logo_alt: 'Gobierno de El Salvador',
  cargando: 'Cargando...',
  placeholder_nombre: 'Nombre completo',
  placeholder_apellido: 'Apellido completo',
  placeholder_email: 'ejemplo@isbm.com',
  placeholder_mensaje: 'Escribe tus comentarios aqui',
  tu_mensaje_ha_sido_enviado: '¡Tu mensaje ha sido enviado con éxito!',
  enviando: 'Enviando...',
  campo_requerido: 'Este campo es requerido',
  formato_invalido_vuelve: 'Formato inválido, vuelve a ingresarlo',
  maximo: 'Máximo %{max} caracteres',
  len: 'Debe contener %{len} caracteres',
  tels_isbm: 'Tels. (503) 2239-9200',
  email_isbm: 'E-mail: tuisbm@isbm.gob.sv',
  ha_ocurrido_un_error: 'Ha ocurrido un error',
  ahora_a_un: '¡Ahora a un clic de distancia!',
  puedes_elegir_una:
    'Puedes elegir una de las opciones de los servicios que ofrecemos en nuestra nueva aplicación del ISBM.',
  consulta_de_medicamentos: 'Consulta de medicamentos',
  consulta_si_tu_receta:
    'Consulta si tu receta está disponible y donde puedes encontrar tus medicamentos.',
  calendarizacion_de_citas: 'Calendarización de citas médicas',
  agendar_citas_ahora:
    'Agendar citas ahora es más fácil, solo necesitas ingresar aquí.',
  preguntas_frecuentes: 'Preguntas frecuentes',
  si_tienes_alguna:
    'Si tienes alguna duda sobre nuestros servicios y gestiones, aquí puedes consultarlas.',
  puedes_dejar_una:
    'Puedes dejar una felicitación, sugerencia o queja, es muy importante saber tu opinión sobre nuestros servicios.',
  siguenos_en_nuestras: 'Síguenos en nuestras redes sociales',
  facebook: 'Facebook',
  twitter: 'Twitter',
  youtube: 'Youtube',
  error: 'Formato inválido, vuelve a ingresarlo',
  descripcion_preguntas:
    'Nuestra prioridad es poderte ayudar, aquí encontrarás respuesta a tus dudas o consultas.',
  sugerir_preguntas: '¿No encuentras la información que buscabas?',
  dejar_sugerencia: '¡Déjanos tu sugerencia!',
  resuelve_tus_dudas: 'Resuelve tus dudas',
  consulta_la_disponibilidad: 'Consulta la disponibilidad de tu medicamento',
  solo_necesitas_dos:
    'Sólo necesitas dos datos para saber si tu medicamento se encuentra disponible en uno de nuestros botiquines',
  ingresa_los_siguientes: 'Ingresa los siguientes datos para consultar.',
  numero_de_afiliado: 'Número de afiliado',
  placeholder_num_afiliado: 'Ej. 1015683',
  numero_de_receta: 'Número de receta',
  placeholder_num_receta: 'Ej. 7481257000',
  buscar_receta: 'Buscar Receta',
  buscando: 'Buscando...',
  numero_afiliado_incorrecto: 'Número de afiliado es incorrecto',
  numero_receta_incorrecto: 'Número de receta es incorrecto.',
  numero_afiliado_inactivo: 'Número de afiliado inactivo',
  numero_dui_inactivo: 'Número de DUI inactivo',
  para_poder_consultar:
    'Para poder consultar tu medicamento debes estar activo.',
  receta_despachada: 'Receta despachada',
  la_receta_ya: 'La receta ya ha sido despachada.',
  receta_no_vigente: 'Receta no vigente',
  el_numero_de_receta:
    'El número de receta no se encuentra vigente. Favor contactar con su médico.',
  medicamento_especial: 'Medicamento especial',
  debe_acercarse_al_establecimiento:
    'Debe acercarse al establecimiento más cercano para recibir una mejor asistencia.',
  informacion_de_receta: 'Información de receta',
  paciente: 'Paciente',
  medicamento: 'Medicamento',
  presentacion: 'Presentación',
  cantidad: 'Cantidad',
  es_este_tu_medicamento: '¿Es este tu medicamento?',
  si: 'Si',
  no: 'No',
  estamos_validando_la: 'Estamos validando la disponibilidad de tu medicamento',
  en_este_momento: 'En este momento no se encuentra disponible tu medicamento',
  puedes_ver_politica:
    'Puedes  ver política de compra y reembolso descargando el siguiente documento.',
  documento_de_descarga: 'Documento de descarga',
  regresar_al_formulario: 'Regresar al formulario',
  de_acuerdo: 'De acuerdo',
  porfavor_dirigirse_a_su_medico:
    'Por favor dirigirse a su médico para rectificar la receta',
  aviso_importante: '¡Aviso importante!',
  recuerda_esta_consulta:
    'Recuerda esta consulta es únicamente informativa y no genera reserva del medicamento.',
  botiquin_magisterial: 'Botiquin Magisterial',
  nueva_consulta: 'Nueva consulta',
  ver_mi_receta: 'Ver mi receta',
  puedes_encontrar_tu_medicamento:
    'Puedes encontrar tu medicamento disponible en los siguientes botiquines',
  fecha_y_hora: 'Fecha y hora de consulta',
  consulta_por_departamento: 'Consulta por nombre, deparamento o municipio.',
  horario_de_atencion: 'Horario de atención',
  direccion: 'Dirección',
  como_llegar: 'Cómo llegar',
  ver_mas: 'Ver más',
  ver_menos: 'Ver menos',
  gracias_por_tu_respuesta: '¡Gracias %{name} por tu espera!',
  consulta_aqui_nuestras:
    'Consulta aquí nuestras políticas de reembolso descargando el siguiente documento.',
  politica_de_reembolso: 'Politica de reembolso',
  numero_de_afiliado_no_encontrado: 'Número de afiliado no encontrado',
  numero_de_dui_no_encontrado: 'Número de DUI no encontrado',
  el_numero_que_ingresaste:
    'El número que ingresaste no se encuentra registrado en nuestra base de datos.',
  informacion_no_encontrada: 'Información no encontrada.',
  el_numero_de_receta_no: 'El número de receta no ha sido encontrada',
  porfavor_dirigete_a_tu_medico:
    'Por favor dirígete a tu médico para confirmar el número de receta.',
  receta_no_asociada: 'Receta no asociada',
  el_numero_de_receta_que:
    'El número de receta que ingresaste no se encuentra asociada a tu número de afiliación.',
  indicaciones: 'Indicaciones',
  back_to_top: 'Regresar arriba',
  mi_receta: 'Mi receta',
  inicio: 'Inicio',
  consulta_medicamento: 'Consulta tu medicamento',
  citas_medicas: 'Citas médicas',
  contactanos: 'Contactanos',
  calendarizacion_de_citas_medicas: 'Calendarización de citas médicas',
  ingresa_los_siguientes_datos_para_consultar:
    'Ingresa los siguientes datos para consultar, si eres menor de edad ingresa DUI del cotizante y número de afiliado que desea hacer la cita.',
  eres_mayor_de_edad: '¿Eres mayor de edad?',
  numero_de_dui: 'Número de DUI',
  siguiente: 'Siguiente',
  placeholder_dui: 'Ej. 05805916-0',
  calendarizar_una_nueva: 'Calendarizar una nueva cita médica',
  tu_cita_ha_sido: '¡%{name} tu cita ha sido confirmada con éxito!',
  comprobante_de_cita: 'Comprobante de cita',
  si_deseas_tu_comprobante:
    'Si deseas tu comprobante de calendarización de tu cita médica puedes dar clic en el siguiente botón',
  gracias_por_usar:
    'Gracias por usar nuestro servicio de calendarización de citas.',
  confirmacion_de_cita_medica: 'Confirmación de cita médica',
  lugar: 'Lugar',
  hora: 'Hora',
  deseo_recibir_un_recordatorio:
    'Deseo recibir un recordatorio a través de correo electrónico',
  esta_seguro_que_desea_confirmar:
    '¿Esta seguro que desea confirmar esta cita médica?',
  no_regresar: 'No, regresar',
  si_confirmar: 'Si, confirmar',
  ingresa_tu_correo_electronico: 'Ingresa tu correo electrónico',
  para_poder_consultar_la_disponibilidad:
    'Para poder consultar la disponibilidad de citas médicas debes tener tu número de afiliado activo.',
  para_poder_agendar_su_cita:
    'Para poder agendar tu cita médica debes tener tu número de afiliado activo.',
  para_poder_consultar_la_disponibilidad_dui:
    'Para poder consultar la disponibilidad de citas médicas debes tener tu número de DUI activo.',
  calendariza_3_pasos: 'Calendariza tu cita en 3 pasos',
  calanderiza_para: 'Estás calendarizando una cita médica para',
  descripcion_calanderiza:
    'Primero, elige tu policlínico o consultorio de preferencia; segundo, selecciona fecha y hora en la cual deseas tu cita y ¡Listo! puedes finalizar tu proceso confirmando tu cita.',
  seleccionar_lugar:
    'Selecciona el policlínico o consultorio de tu preferencia.',
  hora_disponible: 'Horario disponible',
  seleccionar_fecha: 'Selecione una fecha disponible',
  regresar: 'Regresar',
  continuar: 'Continuar',
  confirmar_cita: 'Confirmar mi cita',
  sin_horarios: 'Sin horarios disponibles',
  seleccionar_hora: 'Selecione una fecha disponible',
  confirm_instrunctions:
    'Recuerda siempre tener tu DUI, número de afiliación y comprobante de cita que podrás descargar al confirmar tu cita.',
  numero_de_afiliación: 'Número de afiliación',
  dui: 'DUI',
  fecha: 'Fecha',
  ene: 'Enero',
  feb: 'Febrero',
  mar: 'Marzo',
  abr: 'Abril',
  may: 'Mayo',
  jun: 'Junio',
  jul: 'Julio',
  ago: 'Agosto',
  sep: 'Septiembre',
  oct: 'Octubre',
  nov: 'Noviembre',
  dic: 'Diciembre',
  lo_sentimos: 'Lo sentimos',
  el_horario_para: 'El horario para este establecimiento ya ha sido tomado',
  numero_dui_del_cotizante: 'Número de DUI del cotizante',
  pdf_instructions:
    'Recuerda siempre tener tu DUI, número de afiliación y este comprobante ',
  pdf_instructions2:
    'y recuerda presentarte 15 minutos antes de la hora de tu cita.',
  descargar_pdf: 'Descargar documento',
  clic_aqui: 'Clic aquí',
  el_dui_no_coincide: 'El DUI no coincide con el número de afiliado',
  el_numero_de_dui_que_ingresaste:
    'El número de DUI que ingresaste no está asociado con el número de afiliado.',
  lo_sentimos_este_horario:
    'Lo sentimos, este horario para este establecimiento ya ha sido tomado',
  horario_no_disponible: 'Horario no disponible',
  ocurrio_un_error:
    'Ocurrió un error inesperado, vuelve a intentarlo en unos minutos',
  reservar_medicamento: 'Reservar medicamento',
  deseas_reservar_este_medicamento: '¿Deseas reservar este medicamento?',
  la_reserva_expiro: 'La reserva expiró',
  superate_el_numero_de_intentos:
    'Superaste el número de intentos de reservar tu medicamento de esta receta a través de Tu ISBM. Por favor consulta la disponibilidad de tu receta en tu Botiquín Magisterial más cercano.',
  medicamento_no_retirado: 'Medicamento no retirado',
  el_medicamento_no_fue_retirado_tienes:
    'El medicamento no fue retirado, tienes (%{intentos}) intento más para reservar con esta receta.',
  ya_tienes_una_reserva: 'Ya tienes una reserva',
  tu_reserva_expira: 'Tu reserva expira:',
  no_puedes_hacer_mas_modificaciones: 'No puedes hacer más modificaciones',
  quieres_modificar_la_reserva: '¿Quieres modificar la reserva?',
  esta_es_tu_ultima_modificacion: 'Esta es tu última modificación',
  numero_afiliado: 'Número afiliado',
  dui_no_encontrado: 'DUI no reconocido',
  documento_de_identificacion: '¿Con qué deseas ingresar?',
  medicamento_reservado: '¡Tu medicamento ya está reservado!',
  recuerda_pasar_por_medicamento:
    'Recuerda pasar por tu medicamento en las próximas <b>24 horas</b>, de lo contrario tu reserva será <b>anulada</b>.',
  descargar_comprobante_botiquin:
    'Descarga aquí el comprobante de reserva para retirar tu medicamento del botiquín.',
  descargar_comprobate_reserva: 'Comprobante de reserva',
  puedes_modificar_reserva:
    'Puedes modificar el botiquín de reserva <b>una vez</b> más, siempre y cuando sea antes de la hora de expiración de la reserva.',
  reserva_medicamento_modificada: '¡Tu reserva se ha modificado!',
  no_puedes_modificar_medicamento:
    '<b>No puedes volver a modificar esta reserva de medicamento.</b>',
  comprobante_de_reserva: 'Comprobante de reserva',
  pdf_instructions_medicamento_1:
    'Recuerda siempre tener tu DUI, número de afiliación',
  pdf_instructions_medicamento_2:
    'y este comprobante al momento de recoger tu medicamento.',
  tu_receta_vence_hoy: 'Tu receta vence hoy.',
  si_haces_una_reserva:
    'Si haces una reserva debes reitrar tu medicamento hoy mismo dentro de los horarios de atención del botiquín.',
  si_haces_una_reserva_debes:
    'Si haces una reserva debes retirar tu medicamento hoy mismo.',
  horario_general: 'Horario general de atención:',
  lunes_a_viernes: 'Lunes a viernes: 8:00am-4:00pm',
  sabado: 'Sábado: 8:00am-12:00m',
  horario_aplica_para: '*Horario aplica para todos los botiquines',
  mis_citas: 'Mis citas médicas',
  aqui_encontratas_citas:
    'Aquí encontrarás las citas que agendaste a futuro y podrás ver las citas realizadas anteriormente en Tu ISBM.',
  programa_tus_citas:
    'Programa tus próximas citas, lleva un control de tus citas a futuro o vuelve a ver el histórico de citas agendadas en Tu ISBM.',
  aqui_puedes_ver:
    'Aquí puedes ver las citas que tienes agendadas a futuro y consultar el histórico de citas realizadas en Tu ISBM.',
  agendar_tus_proximas_citas:
    'Agendar tus próximas citas ahora es mas fácil, solo necesitas ingresar aquí.',
  calendarizacion_de_citas_title: 'Calendarización de citas',
  aqui_puedes_consultar_citas:
    'Aquí puedes consultar tus citas médicas agendadas a futuro o también ver tu histórico de citas realizadas en Tu ISBM',
  filtrar: 'Filtrar',
  ordenar: 'Ordenar',
  proximas_citas: 'Próximas citas',
  citas_anteriores: 'Citas anteriores',
  medico: 'Médico',
  creado: 'Creado',
  general: 'General',
  cancelar_cita: 'Cancelar Cita',
  no_tienes_citas_programadas: 'No tienes ninguna cita programada',
  calendarizar_cita: 'Calendarizar cita',
  no_tienes_citas_historial: 'No tienes ninguna cita en tu historial',
  especialista: 'Especialista',
  limpiar: 'Limpiar',
  estas_seguro_que_deseas_cancelar:
    '¿Estás seguro que deseas cancelar la cita?',
  su_cita_fue_cancelada_con_exito: 'Su cita fue cancelada con éxito',
  consulta_los_resultados_de_tus_examenes:
    'Consulta los resultados de tus exámenes',
  ingresa_con_tu_dui:
    'Ingresa con tu DUI o  tu número de afiliado y consulta si los resultados de tus exámenes de laboratorio ya están listos para visualizarlos.',
  selecciona_tu_fecha_de_nacimiento: 'Selecciona tu fecha de nacimiento',
  elegir_fecha: 'Elegir fecha',
  consulta_a_tu_medico: 'Consulta a tu médico',
  los_resultados_de_este_tipo:
    'Los resultados de este tipo de exámen no pueden visualizarse en Tu ISBM, por favor consulta a tu médico para conocer tus resultados.',
  cerrar: 'Cerrar',
  examen: 'Examen',
  tipo_de_examen: 'Tipo de examen',
  recibido_el: 'Recibido el',
  ver_resultado: 'Ver resultado',
  tus_resultados: 'Tus resultados',
  recuerda_que_hay:
    'Recuerda que hay exámenes cuyos resultados no puedes visualizar desde Tu ISBM y debes acudir con tu médico.',
  perdida: 'Perdida',
  completada: 'Completada',
  programada: 'Programada',
  cancelada: 'Cancelada',
  datos_no_coinciden: 'Datos no coinciden',
  su_fecha_de_nacimiento:
    'Su fecha de nacimiento no coincide con su número de afiliado o DUI',
  examenes_de_laboratorio: 'Exámenes de laboratorio',
  aqui_consultar_resultados:
    'Aquí puedes consultar si tus resultados ya están disponibles o visualizarlos desde donde estés.',
  recuerda_que_hay_examenes:
    'Recuerda que hay exámenes cuyos resultados no puedes visualizar desde Tu ISBM y debes acudir con tu médico.',
  ver_examenes: 'Ver exámenes',
  examenes: 'Exámenes',
  emision: 'Emisión',
  completo: 'Completo',
  en_progreso: 'En Proceso',
  en_espera: 'En Espera',
  emitido_el: 'Emitido el',
  consulta_si_tus_resultados:
    'Consulta si tus resultados ya se encuentran disponibles para visualizarlos.',
  consulta_a_tu_meico: 'Consulta  a tu médico',
  resultado: 'Resultado',
  citas: 'Citas',
  reserva: 'Reserva',
  reserva_de_medicamento: 'Reserva de medicamento',
  ayuda: 'Ayuda',
  comenta: 'Comenta',
  reserva_tu_medicamento: 'Reserva tu medicamento',
  abrir_el_menu: 'Abrir el menú',
  cerrar_el_menu: 'Cerrar el menú',
  ups_algo_salio_mal: '¡Ups! Algo salió mal :(',
  por_favor_vuelve:
    'Por favor vuelve cargar la página o intenta de nuevo más tarde',
  historial: 'Historial',
  calendarizacion_citas: 'Calendarización de citas',
  elige_tipo_de_cita: 'Elige el tipo de cita que vas a calendarizar',
  elige_si_deseas_cita: 'Elige si deseas una cita en consulta general o si deseas una cita con un especialista dentro del ISBM.',
  cita_medicina_general: 'Cita en medicina general',
  cita_especialista: 'Cita médica con especialista',
  seleccionar_categoria: 'Seleccionar categoría',
  medico_especialista_en: 'Médicos especialistas en:',
  especialidad: 'Especialidad',
  description_especialidad: 'Elige la especialidad que deseas recibir atención, selecciona al médico que te atenderá y calendariza tu cita sin complicaciones.',
  buscar_especialidad: 'Busca una especialidad',
  buscar_medico: 'Busca un médico o centro de atención',
  dejanos_tu_telefono: 'Por favor, déjanos tu número telefónico en caso que debamos contactarnos contigo',
  numero_de_telefono: 'Ingresa tu número telefónico',
  no_hay_Se_encontraron_resultados: 'No se encontraron resultados',
  reporte_pdf: '',
  reporte_pdf_title: 'Examenes de Laboratorio',
  referencias_title: 'Referencias',
});
